import type {MediaAsset} from '../types';

export type AttachmentDraft={userId?:string;tab?:'video'|'image'|'music'|'voice';prompt?:string;mediaId?:string;mediaName?:string;mediaKind?:MediaAsset['kind'];temporary?:boolean};
export type GeneratorAttachment={id:string;name:string;kind:MediaAsset['kind'];temporary:boolean};

export function attachmentFromDraft(draft:AttachmentDraft):GeneratorAttachment|null{
  if(!draft.mediaId)return null;
  return{id:draft.mediaId,name:draft.mediaName||'Материал',kind:draft.mediaKind||'source_image',temporary:draft.temporary===true};
}

export function browserFileLimit(file:File):{valid:boolean;message?:string}{
  const mib=1024*1024;const image=file.type.startsWith('image/');const limit=image?10*mib:50*mib;
  if(file.size<=limit)return{valid:true};
  return{valid:false,message:`${image?'Изображение':file.type.startsWith('video/')?'Видео':'Аудио'} должно быть не больше ${image?10:50} МБ`};
}
